
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send, X } from "lucide-react";

interface CommentFormProps {
  onSubmit: (content: string) => void;
  onCancel: () => void;
  isLoading: boolean;
}

const CommentForm = ({ onSubmit, onCancel, isLoading }: CommentFormProps) => {
  const [content, setContent] = useState("");

  const handleSubmit = () => {
    if (content.trim()) {
      onSubmit(content);
      setContent("");
    }
  };

  return (
    <div className="mb-6">
      <Textarea
        placeholder="Join the conversation..."
        className="min-h-[80px] text-sm mb-2"
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />
      <div className="flex justify-end gap-2">
        <Button 
          variant="outline"
          onClick={onCancel}
          disabled={isLoading}
          className="gap-2"
        >
          <X className="h-4 w-4" />
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          disabled={isLoading || !content.trim()}
          className="gap-2"
        >
          <Send className="h-4 w-4" />
          Post Comment
        </Button>
      </div>
    </div>
  );
};

export default CommentForm;
